import { ArtefactDto } from '../../apiGateway/Dtos/ArtefactDto';

export const MapDtoToArtefactModel = (dto: ArtefactDto) => {
  return {
    id: dto.id,
    buildConfig: dto.buildConfig.toLowerCase(),
    environment: dto.environment.toLowerCase(),
    extension: dto.extension.toLowerCase(),
    platform: dto.platform.toLowerCase(),
    size: dto.size,
    version: dto.version
  };
};
